const config = {
    basename: '',
    defaultPath: '/',
    fontFamily: `'Roboto', sans-serif`,
    language: 'en',
    borderRadius: 4
};

export default config;
